<template lang="pug">
	div

		div(v-if="$store.state.takeoverInfo && $store.state.takeoverInfo.type=='enroll-now'")
			b-modal.full-screen-modal(id="enroll-now-modal" :hide-header="true" centered no-fade :hide-footer="true" ref="enrollNowModal"  no-close-on-backdrop=true @shown="trackShown" :no-close-on-esc="true")
				div
					a.close-in-word(@click="hideModal()")
						| CLOSE
					h1
						| Another great plan for your consideration
					p We analyze more than 100 plans from accross the country each quarter and select only the best.

					div
						a.simple(:href="`/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=${$store.state.takeoverInfo.planId}&click_source=enroll_now_takeover`" @click="trackClick()")
							b-img-lazy.merril-interstitial(:src="`${$store.state.takeoverInfo.cardImageURL}`")
						a.simple.more-529-plans(:href="$store.state.takeoverInfo.stateURL" @click="trackSecondaryClick()") Show me more {{$store.state.takeoverInfo.stateName}} 529 plans
</template>


<style lang="stylus">
	#exit-modal
		z-index: 5000
	.full-screen-modal
		&.tall-modal-layout
			.modal-body
				padding-top: 0
		.merril-interstitial
			width: 100%
			padding: 0
		.modal-backdrop
			background-color: #0d4378
			&.show
				opacity: 0.9
		&.collegebacker-layout
			.modal-backdrop
				background-color: #eefaf8
				&.show
					opacity: 0.9
		.modal-dialog
			width: 75%
			max-width: 800px
			.modal-content
				background: transparent
				border: 0px solid transparent
				h1
				p
					text-align: center
					color: #fff
				h1
					font-size: body-font-size-xl
				p
					font-size: body-font-size-lg-plus
					&.simple
						text-align: center
				a.simple
					color: #fff
					display: inline-block
					font-size: body-font-size-lg
					margin-top: 15px
					cursor: pointer
					&.more-529-plans
						position: relative
						right: 20px
						display: block
						text-align: right
						top: -30px
						font-size: body-font-size-md
						@media (max-width: 576px)
							top: -10px
				a.btn
					text-transform: uppercase
					text-align: center
					display: table
					margin: 0 auto
					font-size: body-font-size-lg-plus
					padding: 15px 30px
					margin-top: 60px
					border: 2px solid #654003!important
					box-shadow: 0 10px 26px 0 rgba(17, 58, 108, 0.6)
		&.wide-modal-layout
			.modal-dialog
				max-width: 1000px
				.col-md-4
					padding: 0

		a.close-in-word
		&:hover
			font-size: body-font-size-md
			top: -20px
			float: right
			position: relative
			color: #fff
			text-decoration:underline!important

</style>
<script>
	import SfcTrackingService from "@/lib/sfc-tracking-service"

	export default {

		methods:{
			versionCheck(){
				return "V1"
			},

			hideModal() {
				this.trackDismiss()
				this.$store.commit('updateTakeoverInfo', null)
				this.$refs.enrollNowModal.hide()
				document.body.classList.remove('blurbody')
			},

			trackShown(){
				document.body.classList.add('blurbody')
				SfcTrackingService.trackAnalyticsAction('Enroll Now Takeover', 'Show', this.versionCheck())
			},

			trackClick(){
				SfcTrackingService.trackAnalyticsAction('Enroll Now Takeover', 'Click', this.versionCheck(), 0)
			},

			trackDismiss(){
				SfcTrackingService.trackAnalyticsAction('Enroll Now Takeover', 'Dismiss', this.versionCheck())
			},

			trackSecondaryClick(){
				SfcTrackingService.trackAnalyticsAction('Enroll Now Takeover', 'Secondary Click', this.versionCheck(), 0)
			}

		}

	}
</script>
